import { animateScroll } from 'react-scroll';

export const convertArrayOfObjectsToCSV = (array) => {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = Object.keys(array[0]);

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach((item) => {
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key];

      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
};

export const downloadCSV = (array) => {
  const link = document.createElement('a');
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  const filename = 'export.csv';

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename);
  link.click();
};
/*
7 4
3 2
2 1
2 1
4/3 = 1.33
5/3 = 1.66

1 2 3 4 5 6 7 8 9
1 1 1 2 2 2 3 3 3
0 1 1 1 2 2 2 3 3
0 0 1 1 1 2 2 2 3

1 2 3 4 5 6 7 8 9
1 1 2 2 3 3 4 4 5
0 1 1 2 2 3 3 4 4

*/
export const invercionMatriz = (data, columns) => {
  if (columns === 1) return [data];
  const row = Math.ceil(data.length / columns);

  let aux = [];
  const auxFinal = [];
  let acts = [];
  let indice = 0;
  let limit = 0;

  for (let i = 0; row > i; i += 1) {
    indice = i * columns;
    aux.push(data.slice(indice, indice + columns));
  }

  for (let x = 0; x < aux.length; x += 1) {
    for (let y = 0; y < aux[x].length; y += 1) {
      if (!auxFinal[y]) auxFinal[y] = [];
      auxFinal[y][x] = aux[x][y];
    }
  }

  for (let x = 0; x < auxFinal.length; x += 1) {
    acts = [...acts, ...auxFinal[x]];
  }

  aux = [];
  indice = 0;

  const add = acts.length % columns;

  for (let i = 0; columns > i; i += 1) {
    if (add === 0) {
      limit = indice + row;
    } else {
      limit = add <= i ? indice + row - 1 : indice + row;
    }

    aux.push(acts.slice(indice, limit));
    indice = limit;
  }

  return aux;
};

export const convertArrayObjectToOptionComponent = (array, label, value = null) => {
  if (!value) {
    value = label;
  }
  return array.map((item) => ({
    label: item[label],
    value: item[value],
  }));
};

export const adjust = (col, amt) => {
  col = col.replace(/^#/, '');
  if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2];

  let [r, g, b] = col.match(/.{2}/g);
  [r, g, b] = [parseInt(r, 16) + amt, parseInt(g, 16) + amt, parseInt(b, 16) + amt];

  r = Math.max(Math.min(255, r), 0).toString(16);
  g = Math.max(Math.min(255, g), 0).toString(16);
  b = Math.max(Math.min(255, b), 0).toString(16);

  const rr = (r.length < 2 ? '0' : '') + r;
  const gg = (g.length < 2 ? '0' : '') + g;
  const bb = (b.length < 2 ? '0' : '') + b;

  return `#${rr}${gg}${bb}`;
};

export const scrollToBottom = (id) => {
  animateScroll.scrollToBottom({
    containerId: id,
    duration: 0,
  });
};

export const scrollToBottomAnimated = (id) => {
  animateScroll.scrollToBottom({
    containerId: id,
    duration: 250,
  });
};
